import { SyncOperationText } from "@/components/sync/SyncOperationText";
import { UNTITLED_NOTE_TITLE } from "@/domains/untitled/untitled";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { SyncErrorHandlingType } from "@/store/sync/operations/errors/SyncError";
import { IRevokeNoteAclViaSpaceAccountOperation } from "@/store/sync/operations/types";
import { SyncCustomErrorData, SyncOperationKind } from "@/store/sync/types";

export class RevokeNoteAclViaSpaceAccountOperation extends BaseSyncOperation<IRevokeNoteAclViaSpaceAccountOperation> {
  get operationKind(): SyncOperationKind {
    return "REVOKE_NOTE_ACL_VIA_SPACE_ACCOUNT";
  }

  get successToastMessage() {
    return <>Updating access to {this.mediumTitle}...</>;
  }

  get title() {
    return this.store.notes.get(this.payload.id)?.title || UNTITLED_NOTE_TITLE;
  }

  get mediumTitle() {
    return <SyncOperationText>{this.title}</SyncOperationText>;
  }

  handleInvalidError(_errorData: SyncCustomErrorData) {
    this.triggerToast(
      <>
        Access to {this.mediumTitle} could not be updated. If this error continues, please contact
        support.
      </>
    );
  }

  handlePermissionDeniedError(_errorData: SyncCustomErrorData) {
    this.triggerToast(
      <>
        You do not have permissions to update access to {this.mediumTitle}. Please contact the note
        owner.
      </>
    );
  }

  handleUnknownError(_errorData: SyncCustomErrorData) {
    this.triggerToast(
      <>
        Access to {this.mediumTitle} could not be updated. If this error continues, please contact
        support.
      </>,
      SyncErrorHandlingType.RetryWithLimit
    );
  }

  async triggerRecompute() {
    await this.store.notes.recompute(this.payload.id);
  }
}
